import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Refresh } from '../icons'
import { Calculator, Tab } from '.'
import { Table } from 'react-bootstrap'
import { useState, useEffect } from 'react'
import { RateExchangeAPI } from '@api'

const Container = styled.div`
  padding: 16px 16px 24px 16px;
  border: white;
  border-width: 1px;
  border-style: solid;
  box-shadow: 0px -1px 2px rgb(0 0 0 / 5%), 0px 2px 4px rgb(0 0 0 / 10%);
  border-radius: 8px;
`

const THead = styled.thead`
  color: #85714d;

  & th {
    padding: 24px 0 0 0;
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
  }
`

const Tbody = styled.tbody`
  color: #5e514d;

  & td {
    padding-top: 24px;
    padding-bottom: 12px;
    font-size: 16px;
    line-height: 24px;
    border-bottom: 1px solid #edeeee;

    .icon {
      width: 24px;
      height: 24px;
      margin-right: 12px;
    }
  }
`

const Footer = styled.div`
  margin-top: 24px;
  display: flex;
  width: 100%;
  font-size: 0.9em;
`

const Datee = styled.div`
  width: 50%;
  text-align: left;

  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #8a8d8f;
`

const Next = styled.a`
  width: 50%;
  text-align: right;
  color: #f2a900 !important;
  text-decoration: none !important;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;

  &:hover {
    opacity: 0.8;
  }
`

const Header = styled.div`
  font-style: normal;
  font-size: 24px;
  font-weight: 500;
  line-height: 36px;
  color: #5e514d;
  margin-bottom: 28px;

  .title {
    font-weight: bold;
    font-size: 24px;
    line-height: 36px;
    color: #5e514d;
  }
`

const Icon = styled.div`
  width: 36px;
  height: 36px;
  background: rgba(94, 81, 77, 0.1);
  border-radius: 0px 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 16px;

  .icon {
    width: 18px;
    height: 18px;
  }
`

const Td = styled.td`
  display: flex;

  img {
    width: 24px;
    height: 24px;
    margin-right: 24px;
  }
`

const CurrencyIcon = styled.div`
  display: flex;
  align-items: stretch;

  .icon-flag {
    width: 24px;
    height: 24px;
    margin-right: 12px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`

const KURS = () => {
  const { t } = useTranslation()
  const [selectedTab, setSelectedTab] = useState(0)

  return (
    <Container className="h-100">
      <Header>
        <div className="col-8 d-flex justify-content-start align-items-center">
          <Icon>
            <Refresh fill="#5E514D" className="icon" />
          </Icon>
          <div className="title color-brown">{t('kurs')}</div>
        </div>
      </Header>
      <div>
        <Tab.Container>
          <Tab.Item
            selected={selectedTab === 0}
            onClick={() => setSelectedTab(0)}
          >
            {t('forex_rates')}
          </Tab.Item>
          <Tab.Item
            selected={selectedTab === 1}
            onClick={() => setSelectedTab(1)}
          >
            {t('calc')}
          </Tab.Item>
        </Tab.Container>
      </div>
      <div>{selectedTab === 0 ? <ForexRates /> : <Calculator />}</div>
    </Container>
  )
}

const ForexRates = () => {
  const { t } = useTranslation()
  const [currencyUSD, setcurrencyUSD] = useState([])
  const [currencySGD, setcurrencySGD] = useState([])
  const [currencyEUR, setcurrencyEUR] = useState([])
  const [lastUpdated, setlastUpdated] = useState()

  const loadCurrency = async () => {
    const { data } = await RateExchangeAPI()

    if (data.hasil) {
      // SGD
      const currencySGD = data.hasil.find(
        (value) => value.currencyAbbreviation === 'SGD'
      )
      setcurrencySGD(currencySGD ? [{ ...currencySGD }] : [])

      // USD
      const currencyUSD = data.hasil.find(
        (value) => value.currencyAbbreviation === 'USD'
      )
      setcurrencyUSD(currencyUSD ? [{ ...currencyUSD }] : [])

      // EUR
      const currencyEUR = data.hasil.find(
        (value) => value.currencyAbbreviation === 'EUR'
      )
      setcurrencyEUR(currencyEUR ? [{ ...currencyEUR }] : [])
    } else {
      setcurrencyUSD([])
      setcurrencySGD([])
      setcurrencyEUR([])
    }
  }

  const loadLastUpdated = () => {
    // date
    const date = new Date().toLocaleDateString("id-ID")
    let hour = new Date().getHours()
    let minute = new Date().getMinutes()

    if (hour < 10) {
      hour = '0' + hour
    }

    if (minute < 10) {
      minute = '0' + minute
    }

    const lastUpdate = `${date}, ${hour}:${minute}`
    setlastUpdated(lastUpdate)
  }

  useEffect(() => {
    // load currency for the first time
    loadCurrency()
    loadLastUpdated()

    // refresh currency every 15 minutes
    const interval = setInterval(() => {
      loadCurrency()
      loadLastUpdated()
    }, 900000)
    return () => clearInterval(interval)
  }, [])

  const formatValue = (num) => {
    const deleteDot = num.substring(0, num.indexOf('.'))
    const sliceNum = Number(deleteDot.slice(0, 5).toString())
    let formatNumber = ''
    let number = sliceNum.toString().split('').reverse().join('')
    for (let i = 0; i < number.length; i++)
      if (i % 3 === 0) formatNumber += number.substr(i, 3) + '.'
    return formatNumber
      .split('', formatNumber.length - 1)
      .reverse()
      .join('')
  }

  return (
    <div>
      <Table borderless className="mb-0">
        <THead>
          <tr>
            <th>{t('currency')}</th>
            <th>{t('sell')}</th>
            <th>{t('buy')}</th>
          </tr>
        </THead>
        <Tbody>
          {currencySGD.length !== 0 ? (
            currencySGD.map((data, i) => {
              return (
                <tr key={i}>
                  <Td>
                    <CurrencyIcon>
                      <div className="icon-flag">
                        <img
                          className="rounded-circle shadow bg-white icon"
                          src="https://www.countryflags.com/wp-content/uploads/singapore-flag-png-large.png"
                          alt=""
                        />
                      </div>
                      SGD
                    </CurrencyIcon>
                  </Td>
                  <td>{formatValue(data.ttSel)}</td>
                  <td>{formatValue(data.ttBuy)}</td>
                </tr>
              )
            })
          ) : (
            <tr>
              <Td>
                <CurrencyIcon>
                  <div className="icon-flag">
                    <img
                      className="rounded-circle shadow bg-white icon"
                      src="https://www.countryflags.com/wp-content/uploads/singapore-flag-png-large.png"
                      alt=""
                    />
                  </div>
                  SGD
                </CurrencyIcon>
              </Td>
              <td>-</td>
              <td>-</td>
            </tr>
          )}
          {currencyUSD.length !== 0 ? (
            currencyUSD.map((data, i) => {
              return (
                <tr key={i}>
                  <Td>
                    <CurrencyIcon>
                      <div className="icon-flag">
                        <img
                          className="rounded-circle shadow bg-white icon"
                          src="https://www.countryflags.com/wp-content/uploads/united-states-of-america-flag-png-large.png"
                          alt=""
                        />
                      </div>
                      USD
                    </CurrencyIcon>
                  </Td>
                  <td>{formatValue(data.ttSel)}</td>
                  <td>{formatValue(data.ttBuy)}</td>
                </tr>
              )
            })
          ) : (
            <tr>
              <Td>
                <CurrencyIcon>
                  <div className="icon-flag">
                    <img
                      className="rounded-circle shadow bg-white icon"
                      src="https://www.countryflags.com/wp-content/uploads/united-states-of-america-flag-png-large.png"
                      alt=""
                    />
                  </div>
                  USD
                </CurrencyIcon>
              </Td>
              <td>-</td>
              <td>-</td>
            </tr>
          )}
          {currencyEUR.length !== 0 ? (
            currencyEUR.map((data, i) => {
              return (
                <tr key={i}>
                  <Td>
                    <CurrencyIcon>
                      <div className="icon-flag">
                        <img
                          className="rounded-circle shadow bg-white icon"
                          src="https://www.countryflags.com/wp-content/uploads/europe-flag-jpg-xl-768x512.jpg"
                          alt=""
                        />
                      </div>
                      EUR
                    </CurrencyIcon>
                  </Td>
                  <td>{formatValue(data.ttSel)}</td>
                  <td>{formatValue(data.ttBuy)}</td>
                </tr>
              )
            })
          ) : (
            <tr>
              <Td>
                <CurrencyIcon>
                  <div className="icon-flag">
                    <img
                      className="rounded-circle shadow bg-white icon"
                      src="https://www.countryflags.com/wp-content/uploads/europe-flag-jpg-xl-768x512.jpg"
                      alt=""
                    />
                  </div>
                  EUR
                </CurrencyIcon>
              </Td>
              <td>-</td>
              <td>-</td>
            </tr>
          )}
        </Tbody>
      </Table>
      <Footer>
        <i>
          {t('terakhir_diperbarui')} {lastUpdated}
        </i>
        <Datee></Datee>
        <Next href={'/currency-info'}>{t('more')}</Next>
      </Footer>
    </div>
  )
}

export default KURS
